import React from 'react'
import { Form } from './Components/Form'

export const App = () => {
  return (
    <div>
      <Form />
    </div>
  )
}
